import React, {useState ,useEffect} from 'react';
import { useDispatch } from "react-redux";
import moment from 'moment';

import { ConfigProvider} from 'antd';
import 'moment/locale/zh-cn';

import { setshowDivsConditionsGroupeRmBox,setOpenDeleteSpace,setSelected ,setGroupeRmBoxDataActions,setFilterGroupeRmBoxActions} from "../../store/GroupeRmBoxActions";
import { useAppSelector } from "../../../../Redux/hooks";
import UseActionMenu from "./actionsUserTable";
import Hooks from "../../utils/hooks"; 
import { Datagrid } from '@empreinte/components.datagrid';
import { useTranslation } from "react-i18next";
import frFR from 'antd/lib/locale/fr_FR';
import { useMediaQuery } from '@mui/material';
import {GridNorows} from '@empreinte/components.grid-norows';
moment.locale('en');
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

function useDataTableMedia({ columns,  updateEntityPath }: any) {
    const { t } = useTranslation();
    const { handelFilter, handelSearch ,getListGroupeRmBox} = Hooks()
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const [selectedRow] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<any>(DEFAULT_PAGE_NUMBER);
    const [pageSize,setPageSize] = useState<any>(DEFAULT_PAGE_SIZE);
    const [locale] = useState<any>(frFR);
    const totalength = useAppSelector((state)=>state.GroupeRmBoxReducer.totalRecord)
    const List = useAppSelector((state) => state.GroupeRmBoxReducer.List)
    /// i add values 
    const values = useAppSelector((state) => state.GroupeRmBoxReducer.filterGroupeRmBox)
    const searchWord = values.search;
    const tabletColumn = useMediaQuery('(min-width:780px)');
    const mobileColumn = useMediaQuery('(min-width:550px)');
    const dispatch = useDispatch();

  //  get data from db
 
  

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dispatch(
        setshowDivsConditionsGroupeRmBox({
          showDivsConditionsName: "loader",
          showDivsConditionsValue: true,
        })
      )
  return () => { 
    dispatch(setFilterGroupeRmBoxActions({               
    FilterGroupeRmBoxNameChange: "search",
    FilterGroupeRmBoxValueChange: ''
}));
    dispatch(setGroupeRmBoxDataActions([]))
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(()=>{
        getListGroupeRmBox(currentPage,pageSize,searchWord)
// eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPage,pageSize])

    useEffect(()=>{
    if(searchWord)
    setCurrentPage(1)
// eslint-disable-next-line react-hooks/exhaustive-deps
    },[searchWord])
    const updatedColumns = [
        ...columns,
        {
            title: 'Actions',
            key: 5,
            field:'Actions',
            flex:1,
            renderCell: (action: any, record: any) => {
                return (
                    <UseActionMenu record={action} />
                )
            }

        },
    ];

    const filteredeventsfilter = handelFilter(values.type, List)
    const filteredevents = handelSearch(values.search, filteredeventsfilter)


    const resetPagination = () => {
        setCurrentPage(DEFAULT_PAGE_NUMBER);
    };

    function getFilteredEvents(filteredEvents:any, e:any) {
        let tab = filteredEvents.filter((item:any) => {
          return e.includes(item.id);
        });
        let newArray = Array.from(tab, (item:any) => {
          return item.id;
        });
        return newArray;
      }


    const DataTable = () => (
        <div className="DataTable">
            <ConfigProvider locale={locale}>
            {!filteredevents.length || !totalength ?
                <GridNorows  content={t('Zone.noRowsFound')} />
                :
               <Datagrid
                columns={
                    tabletColumn
                      ? updatedColumns
                      : mobileColumn
                        ?  
                          updatedColumns.filter(
                            column =>
                               column.dataIndex !== 'schedule'&&
                               column.dataIndex !== 'syncTime'
                          ):
                           updatedColumns.filter(
                            column =>
                                column.dataIndex !== 'schedule' &&
                                column.dataIndex !== 'syncTime' &&
                                column.dataIndex !== 'bandwidthLimit' 
                          ).filter(
                            column =>
                                column.dataIndex !== 'schedule' &&
                                column.dataIndex !== 'syncTime' 
                          )
                  }
                className={"DataTable__custom-row"}
                height={"calc(90vh - 100px)"}
                selectionModel={selectedRowKeys}
                totalEntities={totalength}
                 checkboxSelection={true}
                checkboxSelect={e => {
                    let newArray = getFilteredEvents(filteredevents, e);
                    setSelectedRowKeys(e);
                    dispatch(setSelected(newArray));
                    dispatch(setOpenDeleteSpace(newArray.length > 0));
 
                    dispatch(setSelected(newArray));
                }}
                // columns={updatedColumns}
                rows={List || filteredevents}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                setPageSize={setPageSize}
                pageSize={pageSize}
                ShowName={t('boitier.AuthorizedIP.rows')}
                EntriesName={t('boitier.AuthorizedIP.element')}
                OfPageName={t('boitier.AuthorizedIP.of')}
                />}
            </ConfigProvider>
        </div>
    );

    return {
        DataTable,
        selectedRow,
        selectedRowKeys,
        currentPage,
        pageSize,
        resetPagination,
    };
}

export default useDataTableMedia;
